export default function forms(){
	const contact_form = document.querySelector( '#gform_fields_2 .gfmc-container' )
	const newsletter_confirm = document.getElementById( 'field_2_6' )
	const captcha = document.querySelector( '.gfield--type-captcha' )
	
	if ( ! contact_form || window.innerWidth > 640 ){ return }

	if ( newsletter_confirm ){
		// move newsletter confirm to the bottom of contact_form
		newsletter_confirm.parentNode.removeChild( newsletter_confirm )
		contact_form.appendChild( newsletter_confirm )
	}

	if ( captcha ){
		// move captcha to the bottom of contact_form
		captcha.parentNode.removeChild( captcha )
		contact_form.appendChild( captcha )
	}
}